import React, { useState, InputHTMLAttributes } from 'react'
import { Field } from 'components'
import classnames from 'classnames'
import styles from './index.module.less'

interface InputProps extends InputHTMLAttributes<any> {
  error?: any
  className?: string
  addonAfter?: React.ReactNode | null | undefined
  placeholder?: string
}

export default function Index({
  error = '',
  className = '',
  addonAfter = undefined,
  value = '',
  onFocus = () => {},
  onBlur = () => {},
  ...props
}: InputProps) {
  const [focus, setFocus] = useState(false)

  return (
    <Field
      error={error}
      className={classnames(
        className,
        styles.input,
        addonAfter ? styles.padRight : '',
        focus ? styles.borderColor : ''
      )}>
      <div className={styles.inputCont}>
        <input
          style={{ flex: 1 }}
          type="password"
          {...props}
          onFocus={e => {
            setFocus(true)
            onFocus(e)
          }}
          onBlur={e => {
            setFocus(false)
            onBlur(e)
          }}
        />
        <div className={styles.addonAfter}>{addonAfter}</div>
      </div>
    </Field>
  )
}
